import { type ButtonProps } from "@mui/material";
import Dialog, { type DialogProps } from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import type { TransitionProps } from "@mui/material/transitions";
import * as React from "react";
import { isMobile } from "react-device-detect";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- mui types;
    children: React.ReactElement<unknown, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface ButtonForDialog extends ButtonProps {
  title: string;
}

interface GenericDialogProps extends DialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  title?: string;
  button?: ButtonForDialog;
}

export const GenericDialog: React.FC<GenericDialogProps> = ({
  children: children,
  open,
  setOpen,
  title,
  button,
  ...dialogProps
}) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      {...dialogProps}
      onClose={handleClose}
      disablePortal
      PaperProps={isMobile ? { sx: { margin: 0, width: "99%", height: undefined } } : undefined}
      aria-describedby="alert-dialog-slide-description"
      fullWidth
      maxWidth="md"
      dir=""
    >
      <DialogTitle>{title}</DialogTitle>
      {open && <DialogContent
        sx={{
          width: "100%",
        }}
      >
        {children}
      </DialogContent>}
    </Dialog>
  );
};
